import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["width"];
import { useCallback } from 'react';
import { PropertyCell } from 'framework-data-table';
import { isDate } from 'customer-data-objects/property/PropertyIdentifier';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import ListingLibDateTimeCell from 'framework-listing-lib/table/ListingLibDateTimeCell';
import { SENTRY_KEYS } from 'framework-listing-lib/utils/sentry';
import ListingLibErrorBoundaryCell from './ListingLibErrorBoundaryCell';
import { Td } from './StyledComponents';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibPropertyCell({
  column,
  columnNamespace,
  requiredCellProps,
  row,
  tdProps
}) {
  const getSecondaryPropertyValue = useCallback(propertyName => getPropertyValue(row, propertyName), [row]);
  let cellComponent;
  if (column.renderCell) {
    cellComponent = column.renderCell({
      crmObject: row,
      propertyName: column.id,
      propertyDefinition: column.propertyDescriptor,
      tdProps
    });
  }
  if (cellComponent) {
    const customCellFingerprint = `${SENTRY_KEYS.CRM_LISTING_CUSTOM_CELL_COMPONENT}_${row.objectTypeId}_${column.id}`;
    return column.hoverCell ? /*#__PURE__*/_jsx(ListingLibErrorBoundaryCell, {
      fingerprint: customCellFingerprint,
      wrapWithTd: true,
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: cellComponent
      })
    }) : /*#__PURE__*/_jsx(Td, Object.assign({}, requiredCellProps, tdProps, {
      children: /*#__PURE__*/_jsx(ListingLibErrorBoundaryCell, {
        fingerprint: customCellFingerprint,
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: cellComponent
        })
      })
    }));
  }
  if (isDate(column.propertyDescriptor)) {
    return /*#__PURE__*/_jsx(Td, Object.assign({}, requiredCellProps, tdProps, {
      children: /*#__PURE__*/_jsx(ListingLibErrorBoundaryCell, {
        fingerprint: `${SENTRY_KEYS.CRM_LISTING_CELL_COMPONENT}_${row.objectTypeId}_${column.id}`,
        children: /*#__PURE__*/_jsx(ListingLibDateTimeCell, {
          crmObject: row,
          propertyName: column.id,
          value: getPropertyValue(row, column.id),
          getSecondaryPropertyValue: getSecondaryPropertyValue
        })
      })
    }));
  }
  const cellProps = _objectWithoutPropertiesLoose(tdProps, _excluded);
  return /*#__PURE__*/_jsx(ListingLibErrorBoundaryCell, {
    fingerprint: `${SENTRY_KEYS.CRM_LISTING_FDT_CELL}_${row.objectTypeId}_${column.id}`,
    children: /*#__PURE__*/_jsx(PropertyCell, {
      objectId: String(row.objectId),
      objectTypeId: columnNamespace,
      value: getPropertyValue(row, column.id),
      propertyDefinition: column.propertyDescriptor,
      canEditObject: false,
      getSecondaryPropertyValue: getSecondaryPropertyValue,
      requiredCellProps: Object.assign({}, cellProps, requiredCellProps)
    })
  });
}